import React, { useEffect } from "react";
import { useState } from "react";
import ConfirmBet from "../confirmBet";
import Selection from "../selection";
import { useLocation } from "react-router-dom";
import { TbPlayFootball } from "react-icons/tb"
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import bettingService from "../../../api/services/bettingService";
import { playSong } from "../../common/actions/common.actions";
import { useDispatch } from "react-redux";
import Modal from "../../common/components/modal";
import { useSelector } from 'react-redux';
import { selectLoginData } from "../login/login.actions";
import { setConfirmData } from '../../common/actions/common.actions';
import dashboardService from "../../../api/services/dashboardService";

const Footer = ({ selectedMatches, fromBody = false, showToastMessage, handleRemoveCard }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showSelectedMatches, setShowSelectedMatches] = useState(false);
    const [showConfirmScreen, setShowConfirmScreen] = useState(false);
    const [betAmount, setBetAmount] = useState('');
    const [maxBetAmount, setMaxBetAmount] = useState(0);
    const [minBetAmount, setMinBetAmount] = useState(0);
    const [balance, setBalance] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalContent, setModalContent] = useState('');

    const handleSongClick = async () => {
        dispatch(playSong());
    };

    const handleConfirmData = (data) => {
        dispatch(setConfirmData(data));
    };
    const { userDetails } = useSelector(selectLoginData);
    const { confirmData } = useSelector((state) => state.common);

    useEffect(() => {
        if (userDetails) {
            const userDetail = JSON.parse(localStorage.getItem("userDetails"));
            
            setBalance(userDetail.balance);
            if (fromBody) {
                setMaxBetAmount(userDetail.betLimitForSingle);
            } else {
                setMaxBetAmount(userDetail.betLimitForMix);
            }
            if (confirmData) {
                setBetAmount(confirmData.betAmount || 0);
            }
        }
    }, [fromBody, confirmData]);

    const openModal = (title, content) => {
        setModalTitle(title);
        setModalContent(content);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        // navigate(-1);
    };

    const validation = () => {
        if (!selectedMatches || (selectedMatches && selectedMatches.length < 1)) {
            return "Please choose at least 1 match!";
        } else if (betAmount && betAmount > balance) {
            return `Bet amount should be less than your balance: ${balance}!`;
        } else if (betAmount && betAmount > maxBetAmount) {
            return `Bet amount should be less than ${maxBetAmount}!`;
        } else if (location.pathname === '/maungg') {
            if (selectedMatches && selectedMatches.length < 2) {
                return "Please choose at least 2 matches!";
            }
        }
    };

    const fetchLock = async () => {
        try {
            const userId = Number(userDetails.userId);
            const response = await dashboardService.getBalanceForDashboard(userId).then((response) => response.json());
            if (response.userInfo) {
                const updatedUserDetails = response.userInfo[0];
                if (updatedUserDetails.lock) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('userDetails');
                    localStorage.removeItem('confirmData');
                    navigate("/login");
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        fetchLock();
    }, []);


    const handleConfirm = async () => {
        try {
            fetchLock();
            const response = await bettingService.getMinMax();
            if (!response.ok) {
                throw new Error("Failed to fetch min/max bet amounts.");
            }
            const data = await response.json();
            const gamblingTypeInfo = data.find(typeInfo => typeInfo.gamblingTypeId === (fromBody ? 1 : 2));
            if (gamblingTypeInfo) {
                setMinBetAmount(gamblingTypeInfo.minBetAmount);
            }
            const error = validation(gamblingTypeInfo);
            if (error) {
                openModal('Lucky 7', error);
                return;
            }

            if (betAmount < gamblingTypeInfo.minBetAmount) {
                openModal('Lucky 7', `Bet amount should be greater than ${gamblingTypeInfo.minBetAmount}!`);
                return;
            }
            handleConfirmData({ betAmount, selectedMatches, isMix: location.pathname === '/maungg' ? true : false });
            handleSongClick();
            navigate("/confirm-bet");
        } catch (error) {
            console.error("Error fetching min/max bet amounts:", error);
        }
    };

    const handleClose = () => {
        console.log("closed!");
    };

    const handleBetAmountChange = (value, balance, setBetAmount) => {
        //console.log("Changing bet amount to:", value,balance);
        // Allow empty string (clear)
        if (value === '') {
            setBetAmount('');
            return;
        }

        const num = Math.floor(Number(value));

        // Invalid or zero and negative
        if (isNaN(num) || num <= 0) {
            return;
        }

        // Enforce limit: must be <= maxBetAmount and <= balance
        if (num <= maxBetAmount && num <= balance) {
            setBetAmount(num);
        }
    }

    return (
        <div className="h-20 bg-gradient-to-r font-bold font-myanmarSansPro from-slate-300 to-slate-200 dark:bg-bg_header_dark flex items-center justify-between px-2 border-t border-slate-400">
            {isModalOpen && (
                <Modal title={modalTitle} content={modalContent} onClose={closeModal} />
            )}
            <label className="text-cus4 dark:text-whitev1 whitespace-nowrap px-1 mx-[1px]">{t('betAmount')}</label>
            <input
                type="number"
                inputMode='numeric'
                value={betAmount}
                // onChange={(e) => {
                //     e.target.value !== '' && e.target.value !== '0' ?
                //         setBetAmount((oldBetAmt) => {
                //             return Math.floor(e.target.value) > maxBetAmount || Math.floor(e.target.value) > balance ? oldBetAmt : Math.floor(e.target.value)
                //         })
                //         : setBetAmount('');
                // }}
                 onChange={(e) => handleBetAmountChange(e.target.value, balance, setBetAmount)}
                className="w-1/2 h-10 mx-[2px] pr-1 border rounded-full focus:outline-none focus:border-white text-cus4  bg-white text-right"
            />
            <button className=" z-10" onClick={handleConfirm}>
                <div className="cursor-pointer bg-gradient-to-r from-waterThree via-waterThree to-waterTwo text-wback dark:text-whitev1 border py-2 px-5 mx-[2px] rounded-full whitespace-nowrap">
                    {t('bet')}
                </div>
            </button>
            {location.pathname === '/maungg' && (
                <div className="flex text-wback bg-slate-400 dark:text-whitev1 dark:bg-transparent border py-2 w-20 mx-[1px] rounded-full justify-center items-center"
                // onClick={handleToggle}
                >
                    <span>{selectedMatches.length} «</span>
                    {/* <TbPlayFootball className="ml-[2px]" color="#fff" size={22} /> */}
                </div>
            )}
            {/* <div
        className={`fixed top-0 left-0 w-full h-screen bg-white z-50 transform transition-transform ${showSelectedMatches ? 'translate-x-0' : '-translate-x-full'
          }`}
      >
        <Selection
          onClose={() => {
            setShowSelectedMatches(false);
            handleSongClick();
          }}
          selectedMatches={selectedMatches}
          betAmount={betAmount}
          handleRemoveCard={handleRemoveCard}
          handleConfirm={handleConfirm}
        />
      </div> */}
            <div
                className={`fixed top-0 left-0 w-full h-screen bg-white z-50 transform transition-transform ${showConfirmScreen ? 'translate-x-0' : '-translate-x-full'
                    }`}
            >
                {/* <ConfirmBet onClose={handleClose} handleRemoveCard={handleRemoveCard} /> */}
            </div>
        </div>
    );
};

export default Footer;
